<template>
  <div id="app">
    <div>
      <Header-el></Header-el>
      <div class style="position: absolute;"></div>
      <div class="user-space">
        <MyNav-el></MyNav-el>
        <article class="user-article">
          <div>
            <div id="accountModule" class="account-page">
              <div>
                <span class="header">账户余额</span>
                <span class="tips">如有问题请拨打客服热线：13919392393 (8:00-24:00)</span>
              </div>
              <div class="account-box">
                <div class="balance-box">
                  <p class="header">当前账户余额</p>
                  <div>
                    <span class="account-num">
                      ￥0
                      <!---->
                    </span>
                    <span class="recharge-bt">我要充值</span>
                  </div>
                </div>
                <div class="display-board" style="height: 0px;">
                  <!---->
                  <!---->
                  <div class="bankcard-box no-account" style="display: flex;">
                    <img
                      src="data:image/png;base64,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"
                      class="img-account"
                    >
                    <div>
                      <p class="header">需开通存管账户</p>
                      <p class="tips">开户绑卡成功后，此卡将作为您充值提现卡，同步完成实名认证，可进行合同签署、全款支付</p>
                      <div class="bt">立即开通</div>
                    </div>
                  </div>
                </div>
              </div>
              <!---->
              <div data-v-56c247c4 transition="modal" class="modal-mask" style="display: none;">
                <div data-v-56c247c4 class="modal-wrapper">
                  <div data-v-56c247c4 class="modal-container" style="width: 350px; height: auto;">
                    <!---->
                    <div data-v-56c247c4 class="modal-header">
                      <h3 data-v-56c247c4>
                        <!---->
                      </h3>
                    </div>
                    <div data-v-56c247c4 class="modal-body modal-body-zero">
                      <div data-v-56c247c4 class="modal-tips">
                        <p data-v-56c247c4>充值金额：￥</p>
                        <!---->
                        <!---->
                        <!---->
                        <!---->
                      </div>
                    </div>
                    <div data-v-56c247c4 class="modal-footer">
                      <div data-v-56c247c4>
                        <div data-v-56c247c4 class="modal-bt">
                          <span data-v-56c247c4 class="ksui-btn cancle-bt">取消</span>
                          <span data-v-56c247c4 class="ksui-btn sure-bt">确定</span>
                        </div>
                        <!---->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="hideForm" style="display: none;"></div>
            </div>
            <div class style="position: absolute;"></div>
          </div>
          <div id="changRModule" class="recharge-module">
            <div class="header">交易明细</div>
            <div class="module-header">
              <span class="module-name actived">充值记录</span>
              <span class="module-name">提现记录</span>
            </div>
            <div data-v-db2f0d16>
              <!---->
              <div class="empty-data">暂无充值记录</div>
            </div>
            <div style="display: none;">
              <!---->
              <div class="empty-data">暂无提现记录</div>
            </div>
          </div>
        </article>
      </div>
      <ul id="nav-share" class="nav-share" style="bottom: 100px; right: 100px;">
        <li class="s-phone">
          <a href="javascript:;"></a>
          <div class="s-phone-hover">
            <p class="sph-t">客服热线（10:00-20:00）</p>
            <p class="sph-p">13919392393</p>
          </div>
        </li>
        <li class="s-wechat">
          <a href="javascript:;"></a>
          <div class="s-wechat-hover">
            <img
              width="100%"
              height="100%"
              src="http://images.kaishiba.com/pc_bottom_qrcode.png"
              alt="wechat"
            >
          </div>
        </li>
        <li class="s-sina">
          <a href="//weibo.com/beginow" target="_blank"></a>
        </li>
        <!---->
      </ul>
    </div>
  </div>
</template>

<script>
import Header from "../components/header";
import Footer from "../components/footer";
import MyNav from "../components/mynav";

export default {
  name: "app",
  components: {
    "Header-el": Header,
    "Footer-el": Footer,
    "MyNav-el": MyNav
  }
};
</script>

<style scoped>
@import url("../css/myindex.css");
</style>
